// Общие HTTP-примитивы: ошибка с кодом статуса и компактный формат времени.

export class ApiError extends Error {
  constructor(
    public status: number,
    public detail: string,
  ) {
    super(detail)
  }
}

/** ISO timestamp -> compact local "YYYY-MM-DD HH:MM"; date-only input stays a date. */
export function fmtTimestamp(v: string | null | undefined): string {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return v
  const p = (n: number) => String(n).padStart(2, '0')
  const date = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
  if (v.length <= 10) return date
  return `${date} ${p(d.getHours())}:${p(d.getMinutes())}`
}
